<ng-container>
    <cb-table
        class="cb-margin-top"
        label="Schedule Items"
        [loaded]="true"
        [minWidth]="750"
        [hideDefaultTable]="true"
    >
        <table cbTable>
            <thead>
                <tr>
                    <td width="220"></td>
                    <td></td>
                    <td>Name</td>
                    <td>Tag(s)</td>
                    <td>Code</td>
                    <td width="320">Product Name/Description</td>
                    <td>Cost Type</td>
                    <td>Quantity</td>
                    @if (!isSkinnyView) {
                        <td style="width: 48px"></td>
                    }
                </tr>
            </thead>
            @for (parentItem of houseAreaIdWithItems?.mappedItems; track parentItem) {
                <tbody class="parent-item">
                    <cb-lot-spec-schedule-items-table-row
                        class="tr parent-row"
                        [ngClass]="{ 'table-warn-no-scrollbar': parentItem.isIncomplete }"
                        [(expandedParents)]="expandedParents"
                        [isExpandCollapseAllClicked]="isExpandCollapseAllClicked"
                        [item]="parentItem"
                        [houseAreaId]="houseAreaIdWithItems?.houseAreaId"
                        [businessEntityId]="businessEntityId"
                        [lotId]="lotId"
                    >
                    </cb-lot-spec-schedule-items-table-row>
                    @if (expandedParents[parentItem.id]) {
                        @for (childItem of parentItem.childItems; track childItem) {
                            <cb-lot-spec-schedule-items-table-row
                                class="tr"
                                [parentItem]="parentItem"
                                [isExpandCollapseAllClicked]="isExpandCollapseAllClicked"
                                [ngClass]="{ 'table-warn-no-scrollbar': childItem.isIncomplete }"
                                [item]="childItem"
                                [businessEntityId]="businessEntityId"
                                [houseAreaId]="houseAreaIdWithItems?.houseAreaId"
                                [lotId]="lotId"
                            >
                            </cb-lot-spec-schedule-items-table-row>
                        }
                    }
                </tbody>
            }
            @if (houseAreaIdWithItems?.mappedItems?.length < 1) {
                <tbody>
                    <tr class="cb-table-footer-row">
                        <td colspan="100%">
                            <cb-info-message
                                message="There are no Schedule Items to display for this House Area"
                                icon="info_circle"
                            ></cb-info-message>
                        </td>
                    </tr>
                </tbody>
            }
        </table>
    </cb-table>
</ng-container>
